import { createApp } from 'vue'
import SitePlanMap from './components/SitePlanMap.vue'
import { createApolloClient, provideApollo } from './composables/useApollo'

const app = createApp(SitePlanMap)

// Create and provide Apollo Client
const apolloClient = createApolloClient()
provideApollo(app, apolloClient)

app.mount('#site-plan-app')
